import React from 'react';
import {Trans, withTranslation} from 'react-i18next';
import {Field, Form as FinalForm} from 'react-final-form';
import {Button, Col, Form, Row, Input} from 'reactstrap';
import LoaderButton from '../components/LoaderButton';
import ModalManager from '../components/modal/ModalManager';
import SecurityVerificationForm from './SecurityVerificationForm';
import {composeValidators, mustBeInteger, mustBeNumber, mustBePositive, required} from '../helpers/Validators';
import {NotificationManager} from '../components/common/react-notifications';
import {numberWithCommas, sleep, stringToNumber} from '../helpers/Utils';
import {baseTokenSymbol} from '../constants/configs';
import Num2persian from '../helpers/NumToPersian';
import FieldError from '../components/FieldError';
import TextField from '../components/TextField';
import Api from '../services/Api';


class BankDepositForm extends React.Component {
  createBankDeposit = async values => {
    const {t, userId} = this.props;
    const payload = {
      ...values,
      userId,
    };
    const action = 'post-admin-ui-user-bank-deposit';
    try {
      const {data} = await Api.invoke('POST', '/admin-ui/access-token', {
        payload: JSON.stringify(payload),
        action,
      });
      ModalManager.close({isOpen: false});
      await sleep(500);
      ModalManager.open({
        isOpen: true,
        title: t('Security Verification'),
        body: this.renderSecurityVerificationForm(action, payload, data),
      });
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  onSubmit = async values => {
    const {t, updateWallets, updateTransactions} = this.props;
    await Api.invoke('POST', '/admin-ui/user-bank-deposit', values);
    NotificationManager.success(t('Bank deposit created successfully'), t('Message'));
    updateWallets();
    updateTransactions();
  };

  renderSecurityVerificationForm = (action, payload, accessData) => {
    return (
      <SecurityVerificationForm
        action={action}
        accessData={accessData}
        onSubmit={async values => {
          await this.onSubmit({
            ...payload,
            ...values,
          });
        }}
      />
    );
  };

  openConfirmDialog = (amount, onConfirm) => {
    const {t, firstName, lastName} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Deposit Confirm'),
      body:
        <div className="text-one">
          <Trans
            i18nKey="confirm_user_bank_deposit"
            values={{
              firstName,
              lastName,
              amount: numberWithCommas(amount),
              amountText: Num2persian(amount),
              token: t(baseTokenSymbol),
            }}
            components={[
              <span className="text-one text-success font-weight-semibold"/>,
              <div className="text-one d-inline-block text-info font-weight-semibold"/>
            ]}
            defaults='Are you sure you want to deposit <span>{{amount}} {{token}}</span> is equivalent to <span>{{amountText}} {{token}}</span> to user with id<br/><div>{{firstName}} {{lastName}}</div>?'
          />
        </div>,
      buttons: [
        {
          color: 'primary',
          onClick: async () => {
            onConfirm();
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Yes'),
        },
        {
          color: 'light',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('No'),
        },
      ],
    });
  };

  render() {
    const {t} = this.props;
    return (
      <FinalForm
        onSubmit={this.createBankDeposit}
        render={({handleSubmit, submitting, pristine, hasValidationErrors, form}) => {
          return (
            <Form>
              <Row>
                <Col>
                  <Field name="amount" validate={composeValidators(required, mustBeNumber, mustBeInteger, mustBePositive)}>
                    {({input}) => (
                      <div>
                        <div style={{marginBottom: 4}}>
                          {`${t('Amount')} (${t(baseTokenSymbol)})`}
                          <span className="required">*</span>
                        </div>
                        <Input
                          {...input}
                          value={numberWithCommas(input.value)}
                          onChange={e => {input.onChange(stringToNumber(e.target.value));}}
                        />
                        <FieldError name="amount"/>
                      </div>
                    )}
                  </Field>
                </Col>
              </Row>
              <Row className="mt-2">
                <Col>
                  <TextField
                    item={{
                      name: 'description',
                      i18n: t('Description'),
                      type: 'textarea',
                      required: true,
                      rows: 3,
                    }}
                  />
                </Col>
              </Row>
              <Row className="mt-4">
                <Col>
                  <LoaderButton
                    color="primary"
                    loading={submitting}
                    disabled={pristine || hasValidationErrors || submitting}
                    className="text-center"
                    style={{minWidth: '100px'}}
                    onClick={() => {
                      this.openConfirmDialog(
                        form.getFieldState('amount').value,
                        handleSubmit,
                      );
                    }}>
                    {t('Submit')}
                  </LoaderButton>
                  <Button
                    color="grey"
                    onClick={() =>{
                      ModalManager.close({
                        isOpen: false
                      });
                    }}
                    className="text-center mx-2"
                    style={{minWidth: '100px'}}>
                    {t('Close')}
                  </Button>
                </Col>
              </Row>
            </Form>
          );
        }}
      />
    );
  }
}

export default withTranslation()(BankDepositForm);
